var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c("div", { staticClass: "filter-field" }, [
          _c("div", { staticClass: "field-content" }, [
            _c(
              "div",
              { staticClass: "field-content-right" },
              [
                _c(
                  "el-row",
                  {
                    staticStyle: {
                      display: "inline-flex",
                      height: "32px",
                      width: "100%",
                    },
                  },
                  [
                    _c(
                      "draggable",
                      {
                        staticClass: "row wrap justify-space-around theme-drag",
                        staticStyle: {
                          width: "100%",
                          height: "100%",
                          margin: "0 10px",
                          "border-radius": "4px",
                          "overflow-x": "auto",
                          display: "flex",
                          "align-items": "center",
                        },
                        attrs: {
                          tag: "v-layout",
                          group: "dimension",
                          animation: "300",
                          move: _vm.onMove,
                        },
                        on: { end: _vm.end2 },
                        model: {
                          value: _vm.element.options.attrs.dragItems,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.element.options.attrs,
                              "dragItems",
                              $$v
                            )
                          },
                          expression: "element.options.attrs.dragItems",
                        },
                      },
                      [
                        _vm._l(
                          _vm.element.options.attrs.dragItems,
                          function (item, index) {
                            return _c(
                              "v-flex",
                              { key: item.id },
                              [
                                _c("drag-item", {
                                  key: item.id,
                                  attrs: { item: item, index: index },
                                  on: { closeItem: _vm.closeItem },
                                }),
                              ],
                              1
                            )
                          }
                        ),
                        _c("span", { attrs: { solt: "footer" } }, [
                          _vm._v(_vm._s(_vm.$t("panel.drag_here"))),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }